// Centralized data for SparkSeed Ventures site
export const BRAND = {
  name: "SparkSeed Ventures",
  tagline: "Backing India's Most Relentless Founders",
  subtagline: "From First Spark to Final Scale — A Venture Studio Built for Builders, Not Boardrooms.",
  closing: "This isn't investment. This is a movement.",
  website: "www.sparkseedventures.in",
};

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "thesis", label: "Thesis" },
  { id: "portfolio", label: "Portfolio" },
  { id: "next-chapter", label: "Roadmap" },
  { id: "returns-lab", label: "Returns" },
  { id: "team", label: "Team" },
  { id: "contact", label: "Contact" },
];

export const MARQUEE_STATS = [
  "200+ startups screened/month",
  "10+ portfolio companies",
  "50+ operator mentors",
  "1 acquisition",
  "₹100 Cr fund",
  "6-month PMF validation",
];

export const OPPORTUNITY_STATS = [
  { value: "$350B+", label: "India startup ecosystem size" },
  { value: "52.6%", label: "Of all new startups from Tier 2 & 3 cities" },
  { value: "45%", label: "YoY startup growth in Tier 2 cities" },
  { value: "200+", label: "Projected unicorns by 2030" },
];

export const OPPORTUNITY_BULLETS = [
  "Less than 8% of institutional capital reaches Tier 2/3 founders",
  "110+ unicorns — most originated outside metro cities",
  "Startups have created 2.1M+ direct jobs across India",
];

export const TIER_FOUNDERS = [
  { name: "Ritesh Agarwal", city: "Rayagada, Odisha", company: "OYO Rooms", value: "$10B" },
  { name: "Deepinder Goyal", city: "Muktsar, Punjab", company: "Zomato", value: "$20B+" },
  { name: "Bhavish Aggarwal", city: "Ludhiana, Punjab", company: "Ola Electric", value: "$7.3B" },
  { name: "Sridhar Vembu", city: "Thanjavur, TN", company: "Zoho", value: "$15B+" },
  { name: "Sachin & Binny Bansal", city: "Chandigarh", company: "Flipkart", value: "$16B" },
  { name: "Vijay Shekhar Sharma", city: "Aligarh, UP", company: "Paytm", value: "$1.1B IPO" },
  { name: "Nithin & Nikhil Kamath", city: "Udupi, Karnataka", company: "Zerodha", value: "$3.6B" },
];

export const FOUNDER_PROBLEMS = [
  { title: "No Mentorship", desc: "Zero structured mentorship at idea/pre-revenue stage." },
  { title: "Pedigree Bias", desc: "VCs only back IIT, IIM, metro-city founders." },
  { title: "No GTM Playbook", desc: "First-time founders have zero GTM or fundraising playbook." },
  { title: "Invisible to Capital", desc: "Tier 2 & 3 founders lack investor network visibility." },
  { title: "Capital Too Late", desc: "Money comes after traction — not before." },
];

export const INVESTOR_PROBLEMS = [
  { title: "Deal Quality", desc: "Most seed funds write cheques without validating PMF." },
  { title: "Lack of Rigor", desc: "Gut-feel investing dominates; no validation process." },
  { title: "No Studio Layer", desc: "VCs invest and advise; no one builds with founders." },
];

export const WHO_WE_ARE = {
  we_are: [
    "An operator-led venture studio",
    "Hands-on from Day 0 to Series B",
    "Tier 2 & 3 native — we go where founders are",
    "PMF-validation discipline before capital",
  ],
  we_arent: [
    "A pedigree-filtered VC",
    "A check-and-disappear accelerator",
    "Metro-only & boardroom-bound",
    "Gut-feel investors chasing logos",
  ],
};

export const COMPARISON = {
  rows: [
    "Hands-on building",
    "PMF validation before capital",
    "Pre-revenue, idea-stage focus",
    "Day 0 to Series B partnership",
    "Tier 2/3 reach",
  ],
  matrix: {
    VC: [false, false, false, false, false],
    Accelerator: [true, false, true, false, false],
    SparkSeed: [true, true, true, true, true],
  },
};

export const THESIS_CARDS = [
  { n: "01", title: "Broken Industries", desc: "Logistics, manufacturing, agri, and retail — ripe for first-principles reinvention." },
  { n: "02", title: "Underserved Markets", desc: "Fragmented, overlooked customer bases that nobody is building for." },
  { n: "03", title: "Capital-Efficient Models", desc: "Lean teams that validate fast, burn discipline as a moat." },
  { n: "04", title: "Operator-Led Startups", desc: "Founders who lived the problem before they pitched the solution." },
];

export const PMF_STEPS = [
  { months: "Stage 01", title: "Spark", desc: "An idea, a founder, a problem worth solving. We engage early — long before traction, often before incorporation." },
  { months: "Stage 02", title: "Seed", desc: "₹0.5–₹2 Cr first cheque. 6-month PMF validation. Operator mentors. Lean GTM playbooks." },
  { months: "Stage 03", title: "Build", desc: "MVP shipped, first paying customers, retention loops. We embed CXOs from our 50+ operator network." },
  { months: "Stage 04", title: "Scale", desc: "Pre-A and Series A follow-on. Co-investor introductions. Pricing, hiring, expansion playbooks." },
  { months: "Stage 05", title: "Exit", desc: "Series B+, strategic acquisition, or IPO track. We stay on cap table from Day 0 to liquidity." },
];

export const FUNNEL_STAGES = [
  { value: 2000, label: "Deal Flow" },
  { value: 600, label: "Preliminary Eval" },
  { value: 300, label: "Due Diligence" },
  { value: 30, label: "IC Meeting" },
  { value: 20, label: "Investment" },
];

export const SCREENING_CRITERIA = [
  "Founder-market fit & execution history",
  "Problem size & addressable market",
  "Early revenue signals / pilot traction",
  "Capital efficiency & burn discipline",
  "Team composition & coachability",
  "Competitive moat & defensibility",
];

export const FUND_TOP_STATS = [
  { value: "₹100 Cr", label: "Target Fund" },
  { value: "25–30", label: "Companies" },
  { value: "2", label: "IPO-Bound" },
  { value: "SEBI", label: "Registered VCF" },
];

export const STAGE_DEPLOYMENT = [
  { stage: "Seed", count: "20–25", inr: "₹0.5 Cr", usd: "$60K" },
  { stage: "Pre-Series A", count: "8–10", inr: "₹2 Cr", usd: "$250K" },
  { stage: "Series A", count: "5–7", inr: "₹5 Cr", usd: "$600K" },
  { stage: "Series B", count: "2–3", inr: "₹8 Cr", usd: "$1M" },
  { stage: "Series C+", count: "1", inr: "₹15 Cr", usd: "$1.8M" },
];

export const ALLOCATION = [
  { name: "First Round", value: 57 },
  { name: "Follow-on", value: 33 },
  { name: "Outliers", value: 10 },
];

export const FUND_TERMS = [
  ["Fund Structure", "SEBI Registered Category I VCF"],
  ["Term", "7 + 1 + 1 years"],
  ["Commitment Period", "36 months"],
  ["Target Corpus", "₹100 Cr ($10.6M)"],
  ["Sponsor Commitment", "₹5 Cr"],
  ["Minimum Contribution", "₹1 Cr / $250K"],
  ["Management Fee", "1.5% annual"],
  ["Hurdle Rate", "12% INR / 9% USD"],
  ["Carry", "12% with full catch-up"],
];

export const PORTFOLIO_COMPANIES = [
  { name: "Very Much Indian", sector: "D2C", stage: "Seed", thesis: "Heritage-led D2C apparel rooted in Indian craft, scaled with modern e-comm rails.", logo: "/portfolio/vmi-clean.png" },
  { name: "Traqo.io", sector: "Logistics", stage: "Series A", thesis: "Real-time freight visibility platform digitising India's $200B trucking market.", logo: "/portfolio/traqo-clean.png" },
  { name: "Cellivate Technologies", sector: "Tech", stage: "Seed", thesis: "Cell-culture media manufacturing for India's emerging biotech and lab-meat sectors.", logo: "/portfolio/cellivate-clean.png" },
  { name: "Ambitio", sector: "SaaS", stage: "Series A", thesis: "AI-powered study-abroad mentor matching ambitious Indian students with top global universities.", logo: "/portfolio/ambitio-clean.png" },
  { name: "CricHeroes", sector: "Tech", stage: "Series B", thesis: "World's largest grassroots cricket network — 30M+ players turning amateur cricket into data.", logo: "/portfolio/cricheroes-clean.png" },
  { name: "Pickup", sector: "Logistics", stage: "Seed", thesis: "Hyper-local last-mile pickups for SMBs in Tier 2 cities the big players ignore.", logo: "/portfolio/pickup-clean.png" },
];

export const PORTFOLIO_STATS = [
  { value: "10+", label: "Companies" },
  { value: "1", label: "Acquisition" },
  { value: "6–8", label: "Deals / yr" },
  { value: "₹2–4 Cr", label: "Avg Check" },
  { value: "4x", label: "Avg MOIC" },
];

export const ECOSYSTEM_PARTNERS = ["IIM Calcutta", "IIM Ahmedabad", "IIT Delhi", "ISB", "SOSV", "AWS"];
export const CORPORATE_PARTNERS = ["DCB Bank", "Mercedes-Benz", "Accenture", "IBM", "Cyient", "FSS", "P&G", "ITC Infotech", "Bajaj", "Quest", "NPCI", "Sequoia", "SOSV"];
export const INVESTMENT_PARTNERS = ["Inflection Point Ventures", "DSG Consumer Partners", "Siana Capital", "LetsVenture", "Venture Catalysts", "Indian Angel Network"];

export const CITIES = [
  { name: "Delhi NCR", desc: "Enterprise & SaaS", x: 50, y: 28 },
  { name: "Surat", desc: "Textiles, trade & D2C", x: 35, y: 50 },
  { name: "Indore", desc: "Emerging startup ecosystem", x: 47, y: 50 },
  { name: "Mangaluru", desc: "Co-working & deep tech", x: 38, y: 78 },
  { name: "Coimbatore", desc: "Manufacturing & industrial tech", x: 45, y: 84 },
  { name: "Karaikudi", desc: "Finance", x: 53, y: 87 },
];

export const MENTOR_CATEGORIES = [
  { title: "Industry Operators", desc: "CEOs and MDs from manufacturing, logistics, and supply chain." },
  { title: "Tech Builders", desc: "CTOs and product leaders from category-defining companies." },
  { title: "Finance & Capital", desc: "CAs, investment bankers, and CFOs who've closed rounds." },
  { title: "GTM & Growth", desc: "Sales, marketing, and growth ops who scaled from 0 to 1." },
];

export const LEADERSHIP = [
  {
    initials: "PR",
    img: "/team/p2.jpg",
    name: "P. Raajashekar",
    role: "Managing Partner",
    bullets: [
      "MD, Lotus Auto — leading businesses in South India",
      "Deep manufacturing & industrial expertise",
      "Tier 2 ecosystem builder",
    ],
  },
  {
    initials: "MS",
    img: "/team/p3.jpg",
    name: "Mayur S B",
    role: "Founder & CEO Builder",
    bullets: [
      "Ex-WFC, VMI, Cart12, Jumbotail, Textron",
      "Fintech, consumer & supply chain expertise",
      "3+ years building the SparkSeed playbook",
    ],
  },
  {
    initials: "AN",
    img: "/team/p4.jpg",
    name: "Abishek Niranjan R",
    role: "Co-Founder",
    bullets: [
      "Fortune City · Lotus Auto operator background",
      "Portfolio ops & founder-side execution",
      "Bengaluru + Coimbatore ecosystem builder",
    ],
  },
];

export const ADVISORS = [
  {
    name: "K. P. Ramaswamy",
    role: "Chairman, KPR Mill Limited",
    bg: "Textiles legend · $3B+ industrial group builder",
    img: "/team/advisors/kpr-ramaswamy.jpg",
  },
  {
    name: "Uma Sekar",
    role: "Director, Avneetha Textiles Pvt. Ltd.",
    bg: "Manufacturing, textile operations & governance",
    img: "/team/advisors/uma-sekar.jpg",
  },
];

export const TEAM_MEMBERS = [
  { name: "Riddhi Mahajan", role: "Associate Director", bg: "ex-Revamp Moto, AY Ventures, IIM Indore", img: "/team/p1.png" },
  { name: "Hruday Gowda", role: "Associate Director", bg: "ex-Ojesh AI, BMSCE", img: "/team/hruday.jpg" },
  { name: "Chandhini Rajan", role: "Investment Manager", bg: "ex-Jumbotail, ABInBev", img: "/team/chandhini.jpg" },
  { name: "Sakshi Chouhan", role: "Investment Manager", bg: "SparkSeed", img: "/team/sakshi.jpg" },
  { name: "Adhaven GPS", role: "Investment Analyst", bg: "ex-Wells Fargo, Christ University", img: "/team/adhaven.jpg" },
  { name: "Ashwani Kumar", role: "Investment Manager", bg: "ex-We Founder Circle, IndiaMART", img: "/team/ashwani.jpg" },
  { name: "Prasanna Oza", role: "Investment Analyst", bg: "SparkSeed", img: "/team/prasanna.jpg" },
];

export const ROADMAP = [
  {
    phase: "Phase 1",
    years: "2024–25",
    title: "Foundations",
    bullets: ["10+ portfolio companies", "1 acquisition", "6–8 deals / yr", "PMF framework live"],
  },
  {
    phase: "Phase 2",
    years: "2025–27",
    title: "Acceleration",
    bullets: ["25 portfolio companies", "3–4 exits", "2 at Series B+", "LP base expanded"],
  },
  {
    phase: "Phase 3",
    years: "2027–30",
    title: "Scale",
    bullets: ["40+ companies funded", "2 IPO-track", "Full Studio infrastructure", "Pan-India"],
  },
];

export const PERSONAS = [
  {
    id: "investors",
    title: "For Investors",
    bullets: [
      "PMF-validated deals before capital deployment",
      "Studio layer structurally reduces downside",
      "Co-investment rights on breakouts",
      "Access to India's most underserved deal flow",
      "4x average MOIC on realized investments",
    ],
  },
  {
    id: "founders",
    title: "For Founders",
    bullets: [
      "₹2–4 Cr pre-seed & seed capital",
      "No pedigree filter — only potential matters",
      "On-ground operators from Day 0 to Series A",
      "6-month PMF validation + GTM playbooks",
      "50+ operator mentors",
    ],
  },
  {
    id: "partners",
    title: "For Strategic Partners",
    bullets: [
      "First look at breakthrough companies",
      "Curated Tier 2/3 deal flow access",
      "Co-build & partnership opportunities",
      "Shared mission to build India 3.0",
      "Ecosystem access across 6 cities",
    ],
  },
];
